module.exports = __webpack_public_path__ + "images/Jakob_Hackel.jpg?v=0514071302286fc4eb2fa038a3cf4f33";